import axios from 'axios';
import {
  EClientType,
  IAuth,
  IAuthLoginPayload,
  IAuthSendOtpPayload,
  IAuthVerifyOtpPayload,
  IAuthSendPhoneOtpPayload,
  IAuthVerifyPhoneOtpPayload,
  IRestorePasswordEmailPayload,
  IRestorePasswordPayload,
  ISessionMeta,
} from 'entities/Auth/Auth.models';
import { getDeviceId } from 'entities/Auth/Auth.helper';

const basePath = 'auth';

const buildSessionMeta = (): ISessionMeta => ({ clientType: EClientType.Web, deviceId: getDeviceId() });

export const authTransport = {
  addAuth: (payload: IAuthLoginPayload): Promise<IAuth> => axios.post(`${basePath}`, { ...payload, ...buildSessionMeta() }),
  deleteAuth: (): Promise<void> => axios.delete(`${basePath}`),
  refreshToken: (refreshToken: string): Promise<IAuth> => axios.put(`${basePath}`, { refreshToken }),
  sendRestorePasswordEmail: (payload: IRestorePasswordEmailPayload): Promise<void> =>
    axios.post(`${basePath}/send-restore-password-email`, payload),
  restorePassword: (payload: IRestorePasswordPayload): Promise<IAuth> =>
    axios.patch(`${basePath}/restore-password`, { ...payload, ...buildSessionMeta() }),
  sendEmail: (payload: IAuthSendOtpPayload): Promise<void> => axios.post(`${basePath}/otp/email/send`, payload),
  verifyEmail: (payload: IAuthVerifyOtpPayload): Promise<IAuth> =>
    axios.post(`${basePath}/otp/email/verify`, { ...payload, ...buildSessionMeta() }),
  sendPhone: (payload: IAuthSendPhoneOtpPayload): Promise<void> => axios.post(`${basePath}/otp/phone/send`, payload),
  verifyPhone: (payload: IAuthVerifyPhoneOtpPayload): Promise<IAuth> =>
    axios.post(`${basePath}/otp/phone/verify`, { ...payload, ...buildSessionMeta() }),
};
